import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { getInitialThemeMode, ThemeMode } from 'theme/themeMode'

interface ThemeState {
  mode: ThemeMode
}

const initialState: ThemeState = {
  mode: getInitialThemeMode()
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload
    },
    toggleThemeMode: (state) => {
      state.mode = state.mode === 'dark' ? 'light' : 'dark'
    }
  }
})

export const { setThemeMode, toggleThemeMode } = themeSlice.actions

export const selectThemeMode = (state: RootState): ThemeMode => state.theme.mode

export default themeSlice.reducer
